import { BaseNode, NodeBadge, shortUrl } from './BaseNode';

interface Endpoint {
  url?: string;
  method?: string;
}

export function HttpTransferNode({
  data,
}: {
  data: { label: string; source?: Endpoint; target?: Endpoint & { mode?: string }; alias?: string };
}) {
  const sourceUrl = shortUrl(data.source?.url);
  const targetUrl = shortUrl(data.target?.url);

  return (
    <BaseNode
      type="http-transfer"
      label={data.label}
      alias={data.alias}
      badge={<NodeBadge>{data.target?.mode ?? 'multipart'}</NodeBadge>}
      lines={[
        sourceUrl && { text: `${data.source?.method ?? 'GET'} ${sourceUrl}`, mono: true },
        targetUrl && { text: `→ ${data.target?.method ?? 'POST'} ${targetUrl}`, mono: true },
      ]}
    />
  );
}
